/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { entitiesListByDocument } from "../../funcs/entitiesListByDocument.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEntitiesByDocumentRequest$inboundSchema,
};

export const tool$entitiesListByDocument: ToolDefinition<typeof args> = {
  name: "entities-list-by-document",
  description: `Get Document Extracted Entities`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await entitiesListByDocument(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
